import { Component, OnInit, Input } from '@angular/core';
import { OHNElement } from '../../../models/ohn-instances';

@Component({
  selector: 'app-date-input-element-config',
  templateUrl: './date-input-element-config.component.html',
  styleUrls: ['./date-input-element-config.component.scss'],
})
export class DateInputElementConfigComponent implements OnInit {

	@Input() el: OHNElement;

  constructor() { }

  ngOnInit() {}

}
